import $$ from "cmn-utils";

const baseUrl = "/api/sys/user/";
export default {
  changePassword: (params) => {
    return $$.post(baseUrl + "change-password", params);
  },
  codeMobile: (params) => {
    return $$.post(baseUrl + "code-mobile", params);
  },
  create: (params) => {
    let data = JSON.parse(JSON.stringify(params));
    Object.keys(data).map((key) => {
      if (
        data[key] === "null" ||
        data[key] === "undefined" ||
        data[key] === null ||
        data[key] === undefined
      )
        delete data[key];
    });
    return $$.post(baseUrl + "create", data);
  },
  delete: (params) => {
    return $$.post(baseUrl + "delete", params);
  },
  existEmail: (params) => {
    return $$.get(baseUrl + "exist-email", params);
  },
  existMobile: (params) => {
    return $$.get(baseUrl + "exist-mobile", params);
  },
  existUsername: (params) => {
    return $$.get(baseUrl + "exist-username", params);
  },
  get: (params) => {
    return $$.get(baseUrl + "get", params);
  },
  getDetail: (params) => {
    return $$.get(baseUrl + "get-detail", params);
  },
  list: (params) => {
    return $$.get(baseUrl + "list", params);
  },
  // listByUnit: (params) => {
  //     return $$.get(baseUrl + 'list-by-unit', params)
  // },
  refreshRegistrationId: (params) => {
    return $$.post(baseUrl + "refresh-registrationId", params);
  },
  resetPasswordMobile: (params) => {
    return $$.post(baseUrl + "reset-password-mobile", params);
  },
  update: (params) => {
    let data = JSON.parse(JSON.stringify(params));
    Object.keys(data).map((key) => {
      if (
        data[key] === "null" ||
        data[key] === "undefined" ||
        data[key] === null ||
        data[key] === undefined
      )
        delete data[key];
    });
    return $$.post(baseUrl + "update", data);
  },
  updateHome: (params) => {
    return $$.post(baseUrl + "update-home", params);
  },
  updateTheme: (params) => {
    return $$.post(baseUrl + "update-theme", params);
  },
  importExcel: (data, formData) => {
    let url = baseUrl + "import-excel";
    if (data) {
      let paramsArray = [];
      //拼接参数
      Object.keys(data).forEach((key) =>
        paramsArray.push(key + "=" + data[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    return $$.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data;boundary=" + new Date().getTime(),
        ...$$.getStore("headers"),
      },
    });
  },
  supImportExcel: (data, formData) => {
    let url = baseUrl + "super-import-excel";
    if (data) {
      let paramsArray = [];
      //拼接参数
      Object.keys(data).forEach((key) =>
        paramsArray.push(key + "=" + data[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    return $$.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data;boundary=" + new Date().getTime(),
        ...$$.getStore("headers"),
      },
    });
  },
  importUserExcelV3: (data, formData) => {
    let url = baseUrl + "import-user-excel-v3";
    if (data) {
      let paramsArray = [];
      //拼接参数
      Object.keys(data).forEach((key) =>
        paramsArray.push(key + "=" + data[key])
      );
      if (url.search(/\?/) === -1) {
        url += "?" + paramsArray.join("&");
      } else {
        url += "&" + paramsArray.join("&");
      }
    }
    return $$.post(url, formData, {
      headers: {
        "content-type": "multipart/form-data;boundary=" + new Date().getTime(),
        ...$$.getStore("headers"),
      },
    });
  },
};
